import { useState } from 'react';

const useTransitionStyles = (transitionStyles, initialStyleKey) => {
    const [transitionStyle, setTransitionStyle] = useState(transitionStyles[initialStyleKey]);

    const setTransition = (styleKey, delay = 10) => {
        // setTransitionStyle(transitionStyles[styleKey]);
        if (delay) {
            setTimeout(() => setTransitionStyle(transitionStyles[styleKey]), delay);
        } else {
            setTransitionStyle(transitionStyles[styleKey]);
        }
    };

    return [transitionStyle, setTransition];
};

export default useTransitionStyles;